module.exports = __webpack_public_path__ + "static/media/black-thin-close-sign.3effe7f8.svg";